import axios from "axios";
import axiosRetry from "axios-retry";
import appConfig from "configs/app.config";
import { attachAuthInterceptors } from "auth/setupApiClient";

let omsServiceAxiosInstance = null;

const createOmsServiceClient = () => {
  omsServiceAxiosInstance = axios.create({
    baseURL: appConfig.api.domain,
    timeout: appConfig.api.timeout,
    withCredentials: true,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });

  attachAuthInterceptors(omsServiceAxiosInstance);
  axiosRetry(omsServiceAxiosInstance, { retries: appConfig.api.retry });
  return omsServiceAxiosInstance;
};

const createOmsServiceClientForPDF = () => {
  const pdfClient = axios.create({
    baseURL: appConfig.api.domain,
    timeout: appConfig.api.timeout,
    withCredentials: true,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/pdf",
    },
    responseType: "arraybuffer",
  });

  attachAuthInterceptors(pdfClient);
  axiosRetry(pdfClient, { retries: appConfig.api.retry });
  return pdfClient;
};

export const invokeOmsService = async (requestParams) => {
  const client = createOmsServiceClient();

  console.debug("Request Params for axios", requestParams);
  try {
    const response = await _invokeAxios(client, requestParams);
    return response;
  } catch (error) {
    throw error;
  }
};

export const invokeOmsServiceForPDF = async (requestParams) => {
  const client = createOmsServiceClientForPDF();

  console.debug("Request Params for axios", requestParams);
  try {
    const response = await _invokeAxios(client, requestParams);
    return response;
  } catch (error) {
    throw error;
  }
};

export const queryOmsService = async (requestParams) => {
  const response = await invokeOmsService(requestParams);

  if (response.status === 200) {
    return response.data;
  }
  if (response.status === 404) {
    return [];
  }
  throw new Error("Error in querying OMS service");
};

export const uploadFile = async (fileBlobUrl, omsUrl) => {
  const client = createOmsServiceClient();
  const fileUploadFormData = new FormData();
  if (fileBlobUrl instanceof File) {
    fileUploadFormData.append("file", fileBlobUrl);
  } else {
    const blob = await fetch(fileBlobUrl).then((response) => response.blob());
    fileUploadFormData.append("file", blob);
  }
  return await client.post(omsUrl, fileUploadFormData, {});
};

const _invokeAxios = async (client, requestParams) => {
  requestParams.method = requestParams.method || "GET";
  const isFormData =
    typeof FormData !== "undefined" && requestParams.body instanceof FormData;
  const config = {
    ...(isFormData ? { headers: { "Content-Type": undefined } } : {}),
    ...(requestParams.timeout != null ? { timeout: requestParams.timeout } : {}),
  };

  if (requestParams.method.toLowerCase() === "post") {
    return await client.post(requestParams.url, requestParams.body, config);
  }
  if (requestParams.method.toLowerCase() === "put") {
    return await client.put(requestParams.url, requestParams.body, config);
  }
  if (requestParams.method.toLowerCase() === "patch") {
    return await client.patch(requestParams.url, requestParams.body, config);
  }
  if (requestParams.method.toLowerCase() === "delete") {
    return await client.put(requestParams.url, requestParams.body);
  }
  if (requestParams.method.toLowerCase() === "strict_delete") {
    return await client.delete(requestParams.url, requestParams.body);
  }
  return await client.get(requestParams.url);
};
